var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/copy_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 10.175V13.325C12 15.95 10.95 17 8.325 17H5.175C2.55 17 1.5 15.95 1.5 13.325V10.175C1.5 7.55 2.55 6.5 5.175 6.5H8.325C10.95 6.5 12 7.55 12 10.175Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8253 2H9.67531C7.46288 2 6.37452 2.75121 6.08673 4.55369C5.99892 5.10363 6.4628 5.5625 7.01972 5.5625H8.32531C11.4753 5.5625 12.9378 7.025 12.9378 10.175V11.4806C12.9378 12.0375 13.3967 12.5014 13.9466 12.4136C15.7491 12.1258 16.5003 11.0374 16.5003 8.825V5.675C16.5003 3.05 15.4503 2 12.8253 2Z",
    fill: "#374151"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b57e3af1a5e52b9df338b9e1ef039a1c.svg";
export { ForwardRef as ReactComponent };